// Dynamically determine API URL based on environment
const getApiUrl = () => {
  // Use REACT_APP_API_URL from .env if available (for production builds)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL + '/api';
  }

  // Development: use localhost
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:5000/api';
  }

  // Production fallback
  return 'https://cabanaapi.octaviantweaking.com/api';
};

const API_URL = getApiUrl();

console.log(`[API Client] Using API URL: ${API_URL}`);

/* ── Helper: make authenticated requests ── */
async function request(endpoint, options = {}) {
  const token = localStorage.getItem('token');

  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
      ...options.headers,
    },
    ...options,
  };

  const response = await fetch(`${API_URL}${endpoint}`, config);
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Something went wrong');
  }

  return data;
}

/* ── Auth API ── */
export const api = {
  // Register a new user
  register: (email, password, full_name, phone) =>
    request('/auth/register', {
      method: 'POST',
      body: JSON.stringify({ email, password, full_name, phone }),
    }),

  // Login
  login: (email, password) =>
    request('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),

  // Get current user profile
  getProfile: () => request('/auth/me'),

  // Update profile
  updateProfile: (updates) =>
    request('/auth/me', {
      method: 'PUT',
      body: JSON.stringify(updates),
    }),

  // Get all bookings (public — for calendar)
  getBookings: () => request('/bookings'),

  // Get my bookings (protected)
  getMyBookings: () => request('/bookings/mine'),

  // Get my booking stats & loyalty info (protected)
  getMyStats: () => request('/bookings/stats'),

  // Create a booking (protected)
  createBooking: (check_in, check_out, guests, notes) =>
    request('/bookings', {
      method: 'POST',
      body: JSON.stringify({ check_in, check_out, guests, notes }),
    }),

  // Cancel a booking (protected)
  cancelBooking: (id) =>
    request(`/bookings/${id}`, {
      method: 'DELETE',
    }),

  // ── Reviews ──

  // Get all reviews (public)
  getReviews: () => request('/reviews'),

  // Create a review (protected)
  createReview: (review) =>
    request('/reviews', {
      method: 'POST',
      body: JSON.stringify(review),
    }),

  // Update a review (protected)
  updateReview: (id, review) =>
    request(`/reviews/${id}`, {
      method: 'PUT',
      body: JSON.stringify(review),
    }),

  // Delete a review (protected)
  deleteReview: (id) =>
    request(`/reviews/${id}`, {
      method: 'DELETE',
    }),

  // Toggle helpful vote (protected)
  toggleHelpful: (id) =>
    request(`/reviews/${id}/helpful`, {
      method: 'POST',
    }),

  // Get my helpful votes (protected)
  getMyVotes: () => request('/reviews/my-votes'),
};
